import { useEffect as u } from "react";
var p = /* @__PURE__ */ ((r) => (r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.ArrowUp = "ArrowUp", r.ArrowDown = "ArrowDown", r.ArrowLeft = "ArrowLeft", r.ArrowRight = "ArrowRight", r.Tab = "Tab", r.Space = " ", r))(p || {});
const d = ({
  ref: r,
  onEnter: t,
  onEscape: s,
  onBackspace: c,
  onArrowUp: n,
  onArrowDown: k,
  onArrowLeft: i,
  onArrowRight: w,
  onSpace: o,
  onTabNext: b,
  onTabPrev: f
}) => {
  u(() => {
    const a = r?.current;
    if (!a) return;
    const E = (e) => {
      if (a instanceof Element && document.activeElement === a)
        switch (e.key) {
          case "Enter":
            t?.(e);
            break;
          case "Escape":
            s?.(e);
            break;
          case "Backspace":
            c?.(e);
            break;
          case "ArrowUp":
            n?.(e);
            break;
          case "ArrowDown":
            k?.(e);
            break;
          case "ArrowLeft":
            i?.(e);
            break;
          case "ArrowRight":
            w?.(e);
            break;
          case " ":
            o?.(e);
            break;
          case "Tab":
            e.shiftKey ? f?.(e) : b?.(e);
            break;
        }
    };
    return a.addEventListener("keydown", E), () => {
      a.removeEventListener("keydown", E);
    };
  }, [
    r,
    t,
    s,
    c,
    n,
    k,
    i,
    w,
    o,
    b,
    f
  ]);
};
export {
  p as Key,
  d as useKeyboardEvents
};
